import React, {FC, useContext, useEffect, useState} from 'react';
import {TextArea} from '../../form';
import Select from '../../../components/select';
import CusttomAudioPlayer from '../../audio-player';
import {
  ERROR_MESSAGES,
  freeToolsErrors,
  genderOptions,
  returnSocketLink,
  voiceContryOptions,
} from '../../../helpers/constants';
import {getVoices, toolRequest, request} from '../../../requests';
import ProgressWithHint from '../../progress-hint';
import GoToLoginPage from '../tools-login';
import DataList from '../../dataList';
import LimitReached from '../limit-modal';
import {UserContext, UserType} from '../../../helpers/contexts/user-context';
import {HexomaticUserContext, HexomaticUserType} from '../../../helpers/contexts/hexomatic-user';
import Button from '../../button';
import {Link} from 'gatsby';
import {GET_HEXOMATIC_USER} from '../../../graphql/queries';
import {useQuery} from '@apollo/react-hooks';
import {getHintPopupPerTool} from '../../../helpers';

const TextToSpeechAction: FC<{source?: string; file?: string}> = ({source, file}) => {
  const hintName = 'free-tools-hint-text-to-speech';
  const {user} = useContext(UserContext);
  const {hexomaticUser} = useContext(HexomaticUserContext);

  //-------------------------State------------------------------
  const [socket, setSocket] = useState<any>(null);
  const [socketId, setSocketId] = useState('');
  const [text, setText] = useState('');
  const [textArray, setTextArray] = useState(['', '']);
  const [language, setLanguage] = useState({label: '', value: ''});
  const [gender, setGender] = useState({label: 'Select', value: ''});
  const [src, setSrc] = useState('');
  const [timeStamp, setTimeStamp] = useState(0);
  const [play, setPlay] = useState(false);
  const [allDialects, setAllDialects] = useState([]);
  const [dilects, setDilects] = useState([]);
  const [voice, setVoice] = useState({label: 'Select', value: ''});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [limit, setLimit] = useState('');
  const [limitReached, setLimitReached] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [show, setShow] = useState(false);
  const [showCreditsModal, setShowCreditsModal] = useState(false);
  const [requierd, setRequeird] = useState(false);
  const [clientId, setClientId] = useState('');
  const [mainUser, setUser] = useState<null | UserType>(null);
  const [hexomaticMainUser, setHexomaticUser] = useState<null | HexomaticUserType>(null);

  const {data: hexomaticUserData} = useQuery(GET_HEXOMATIC_USER, {
    fetchPolicy: 'no-cache',
    skip: !!getHintPopupPerTool(hintName),
  });
  //----------useEffect-------------------

  useEffect(() => {
    if (hexomaticUserData && hexomaticUserData.HexomaticUser && hexomaticUserData.HexomaticUser.getByLegacyId) {
      setHexomaticUser(hexomaticUserData.HexomaticUser.getByLegacyId);
    }
    if (hexomaticUserData && hexomaticUserData.User && hexomaticUserData.User.get) {
      setUser(hexomaticUserData.User.get);
    }
  }, [hexomaticUserData]);

  useEffect(() => {
    !file && socketStart();
    // if (localStorage.getItem('textToSpeechSocketId')) {
    //   getResult();
    //   setSocketId(localStorage.getItem('textToSpeechSocketId') || '');
    //   if (localStorage.getItem('textToSpeechInfo')) {
    //     const info = JSON.parse(localStorage.getItem('textToSpeechInfo') || '');
    //     info.text && setText(info.text);
    //     info.voice && setVoice(info.voice);
    //     info.language && setLanguage(info.language);
    //     info.gender && setGender(info.gender);
    //   }
    // }
  }, []);

  useEffect(() => {
    if (!socket || file) return;
    socket.onerror = function() {
      console.log('Connection Error');
    };

    socket.onopen = function() {
      console.log('WebSocket Client Connected');
    };

    socket.onclose = () => {
      socketStart();
    };
    return () => {
      socket.close();
    };
  }, [socket]);

  useEffect(() => {
    if (!socket || file) return;
    socket.onmessage = function(e: any) {
      const data = e ? JSON.parse(e.data) : '';
      if (data && data.clientId !== clientId) {
        setClientId(data.clientId);
        return;
      }
      if (data && data.error && freeToolsErrors.includes(data.error)) {
        setLimit(data.error);
        setShow(false);
        setLoading(false);
        setSocketId('');
        return;
      }
      if (data && data.socketId !== socketId) return;
      data._text_to_speech ? setSrc(data._text_to_speech[0].replaceAll('///', '/')) : setError('Something went wrong');
      setSocketId('');
      setShow(false);
      //localStorage.removeItem('textToSpeechInfo');
      //localStorage.removeItem('textToSpeechSocketId');
    };
  }, [socketId, clientId, socket]);

  useEffect(() => {
    const time = document.getElementById('rhap_current-time');
    const fullTime = document.querySelector('.rhap_total-time');
    if (fullTime && time) {
      const transText = text || source;
      const percent = getPercent(time.innerText, fullTime.innerHTML);
      const a = transText && transText.slice(0, Math.ceil((transText.length * percent) / 93.5));
      transText && a && setTextArray([a, transText.replace(a, '')]);
      percent === 100 && transText && setTextArray([transText, '']);
      !percent && transText && setTextArray(['', transText]);
    }
  }, [src, timeStamp, play, source]);

  useEffect(() => {
    const selectOptionFrom = voiceContryOptions.find(
      (item: {label: string; value: string}) => item.label === language.label,
    );
    if (selectOptionFrom) fetchLang(selectOptionFrom.value);
    else setAllDialects([]);
  }, [language]);

  useEffect(() => {
    setIsChange(true);
  }, [gender, voice, language, text]);

  useEffect(() => {
    const arr =
      gender.value === 'NEUTRAL' ? allDialects : allDialects.filter((item: any) => item.gender === gender.value);
    setDilects(arr);
    setVoice(arr[0] || {label: 'Select', value: ''});
  }, [gender, allDialects]);

  //-----------------------functions--------------------------
  const socketStart = () => {
    //@ts-ignore
    const newSocket = new WebSocket(returnSocketLink());
    setSocket(newSocket);
  };
  const handleListen = (e: any) => {
    setTimeStamp(e.timeStamp);
  };
  const getPercent = (str: string, str1: string) => {
    const start = +str.slice(0, str.indexOf(':')) * 60 + +str.slice(str.indexOf(':') + 1);
    const end = +str1.slice(0, str1.indexOf(':')) * 60 + +str1.slice(str1.indexOf(':') + 1);
    return Math.ceil((100 * start) / end);
  };

  const fetchLang = async (lang: string) => {
    const voices = await getVoices(lang);
    voices && setAllDialects(voices);
  };

  const handlePause = () => setPlay(false);
  const handlePlay = () => {
    setPlay(true);
  };

  const handleClick = async () => {
    if (show || loading) return;
    if (!language.value || !gender.value || !text || !text.trim()) {
      setRequeird(true);
      return;
    }
    setRequeird(false);
    if (!getHintPopupPerTool(hintName) && user && user.id) {
      setShowCreditsModal(true);
      return;
    }
    setSrc('');
    setShow(false);
    setIsChange(false);

    try {
      setLoading(true);
      const res = await toolRequest('text-to-speech', text, {
        langCode: language.value,
        gender: gender.value,
        name: voice.value,
        clientId,
        requestSource: 'free_tools',
      });
      if (res.status === 403) {
        setLimitReached(true);
        setLoading(false);
        return;
      }
      if (res?.data?.socketId) {
        setSocketId(res.data.socketId);
        // localStorage.setItem('textToSpeechSocketId', res.data.socketId);
        //localStorage.setItem('textToSpeechInfo', JSON.stringify({text, voice, language, gender}));
        setError('');
        setShow(true);
      } else if (res.errorData) {
        if (ERROR_MESSAGES[res.errorData.message]) {
          setLimit(ERROR_MESSAGES[res.errorData.message]);
        } else {
          setError('Something went wrong. Please try again.');
        }
      }
      setLoading(false);
    } catch (error) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };
  const handleChangeModalState = () => {
    setLimitReached(false);
  };
  const getResult = async () => {
    if (!socketId) return;
    try {
      //setLoading(true);
      const res: any = await request(`result/${socketId}`);
      if (
        res &&
        res.data &&
        res.data.result &&
        res.data.result.error &&
        freeToolsErrors.includes(res.data.result.error)
      ) {
        setLimit(res.data.result.error);
        setShow(false);
        setLoading(false);
        setSocketId('');
        return;
      }
      if (res && res.data && res.data.result && res.data.result._text_to_speech) {
        //localStorage.removeItem('textToSpeechSocketId');
        //localStorage.removeItem('textToSpeechInfo');
        setSrc(res.data.result._text_to_speech[0].replaceAll('///', '/'));
        setShow(false);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };
  const handleChangeLanguage = (item: any) =>
    setLanguage(voiceContryOptions.find((el: any) => el.label === item) || {label: item, value: ''});
  //----------------------------------------------
  return (
    <div className="d-block m-auto w-100">
      {file ? (
        <div style={{maxWidth: '785px', margin: 'auto'}} className="pb-2">
          <Link to="/tools/history/#text-to-speech">← Back to history</Link>
        </div>
      ) : (
        <div className="d-flex pb-2" style={{maxWidth: '785px', margin: 'auto'}}>
          <Link className="n-wrap" to="/tools">
            ← Back to tools
          </Link>
          <Link to="/tools/history/#text-to-speech" className="n-wrap ml-auto">
            See history →
          </Link>
        </div>
      )}
      <div className="text-to-speech-action">
        <div className={`form ${file ? 'history-form' : ''}`}>
          {(src && play) || file ? (
            <div className="textarea-clone">
              <span className="hexomatic-color">{textArray[0]}</span>
              <span className="scroll-view">{textArray[1]}</span>
            </div>
          ) : (
            <TextArea
              name="text"
              value={text}
              onChange={(e: any) => setText(e.target.value)}
              rows={4}
              className={`textarea ${requierd && (!text || !text.trim()) ? 'border-empty' : ''}`}
              maxLength={hexomaticUser && hexomaticUser.id && hexomaticUser.pricing_package !== 'FREE' ? 4500 : 1000}
              isShowLength
              disabled={loading}
              disableResize
            />
          )}
          {!file && (
            <div className="fields-wrapper mx-0 row mb-2">
              <div className="col-12 col-sm-4">
                <label>Language</label>
                <DataList
                  list={voiceContryOptions}
                  value={language.label}
                  placeholder={'Select'}
                  //@ts-ignore
                  onChange={handleChangeLanguage}
                  disabled={play}
                  className={`${requierd && !language.value ? 'error-border' : ''}`}
                />
              </div>
              <div className="col-12 col-sm-4">
                <label>Gender</label>
                <Select
                  options={genderOptions}
                  onChange={setGender}
                  value={gender}
                  disabled={play}
                  empty={requierd && !gender.value}
                />
              </div>
              <div className="col-12 col-sm-4">
                <label>Voices</label>
                <Select options={dilects} onChange={setVoice} value={voice} disabled={play} />
              </div>
            </div>
          )}
          <div className={`position-relative player-wrap ${file ? 'mt-4 history-player' : ''}`}>
            <CusttomAudioPlayer
              download
              src={src || file || ''}
              onPlay={handlePlay}
              onPause={handlePause}
              onListen={handleListen}
              showDownloadProgress={!src || !file}
              onPlayError={handleClick}
              autoplay={!!src}
            />
            {!file && (
              <Button className="go-btn" onClick={handleClick} disabled={show || loading}>
                Go
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className={`mx-auto col-12 my-1 ${loading || (socketId && !src) ? 'visible' : 'invisible'}`}>
        {show && <ProgressWithHint func={getResult} />}
      </div>
      <div className={`alert alert-danger py-1 my-0 mx-auto ${error ? 'visible' : 'invisible'}`} role="alert">
        {error || 'error'}
      </div>
      {limitReached && <GoToLoginPage toolName="Text to Speech" setOpen={handleChangeModalState} />}
      {limit && <LimitReached text={limit} setLimit={setLimit} />}
      {showCreditsModal && (
        <LimitReached
          hint_name={hintName}
          defaultModal
          hideModal={setShowCreditsModal}
          automation_credits={1}
          premium_credits={0.0008}
          confirm={handleClick}
          user={mainUser}
          hexomaticUser={hexomaticMainUser}
        />
      )}
    </div>
  );
};
export default TextToSpeechAction;
